/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_TranscriptInputs */

const en_text_transcript = /** @type {(inputs: Text_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Transcript`)
};

const fr_text_transcript = /** @type {(inputs: Text_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription texte`)
};

const de_text_transcript = /** @type {(inputs: Text_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texttranskript`)
};

const it_text_transcript = /** @type {(inputs: Text_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione del testo`)
};

const ru_text_transcript = /** @type {(inputs: Text_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текстовая расшифровка`)
};

const es_text_transcript = /** @type {(inputs: Text_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción del texto`)
};

const zh_cn2_text_transcript = /** @type {(inputs: Text_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本转录`)
};

const ja_text_transcript = /** @type {(inputs: Text_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストトランスクリプト`)
};

const hi_text_transcript = /** @type {(inputs: Text_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ प्रतिलेख`)
};

const pt_pt2_text_transcript = /** @type {(inputs: Text_TranscriptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição do texto`)
};

/**
* | output |
* | --- |
* | "Text Transcript" |
*
* @param {Text_TranscriptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_transcript = /** @type {((inputs?: Text_TranscriptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_TranscriptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_text_transcript(inputs)
	if (locale === "de") return de_text_transcript(inputs)
	if (locale === "it") return it_text_transcript(inputs)
	if (locale === "ru") return ru_text_transcript(inputs)
	if (locale === "es") return es_text_transcript(inputs)
	if (locale === "zh-CN") return zh_cn2_text_transcript(inputs)
	if (locale === "ja") return ja_text_transcript(inputs)
	if (locale === "hi") return hi_text_transcript(inputs)
	if (locale === "pt-PT") return pt_pt2_text_transcript(inputs)
	return en_text_transcript(inputs)
});